// extracted by mini-css-extract-plugin
export default {"NotFound":"NotFound_NotFound__fWWsD","Link":"NotFound_Link__EO8Xy"};